import { api, ReactQueryOptions } from '@api';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
import { gtagEventTrigger } from '@specs/helpers';
import { useShowToast } from '@hooks/useShowToast';
type optionsType = ReactQueryOptions['UserManager']['collectBonus'];
export const useCollectBonus = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const {
    onSuccess
  } = options ?? {};
  const {
    updateStoreItemsData,
    updateSpaceCollectionsData
  } = useInvalidate();
  return api.UserManager.collectBonus.useMutation({
    ...options,
    mutationKey: ['UserManager.collectBonus'],
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
      if (data.status === 'reject') {
        const code_error = data.code;
        if (code_error === 'main.bonusToy.notAvailable') {
          showToast({
            variant: 'error',
            text: code_error
          });
        }
        return;
      }
      gtagEventTrigger({
        action: 'adding_to_collection',
        category: 'commerce'
      });
    },
    onSettled: (data, _, variables) => {
      const {
        collectionId,
        toyId
      } = variables;
      if (data?.status === 'success') {
        updateStoreItemsData({
          toyId
        });
        updateSpaceCollectionsData({
          collections: [collectionId]
        });
      }
    }
  });
};